document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper === "undefined") {
    return;
  }

  /* =========================
   * HERO SLIDER (EXISTANT)
   * ========================= */
  const heroSwiperEl = document.querySelector(".hero-swiper .swiper");

  if (heroSwiperEl) {
    new Swiper(heroSwiperEl, {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".hero-swiper .swiper-pagination",
        clickable: true,
      },
      effect: "slide",
    });
  }

  /* =========================
   * GALLERY SLIDERS (EXISTANT)
   * ========================= */
  document.querySelectorAll(".gallery-swiper").forEach(function (slider) {
    const thumbsEl = slider.querySelector(".gallery-thumbs");
    const mainEl = slider.querySelector(".gallery-top");

    if (!thumbsEl || !mainEl) {
      return;
    }

    const thumbsSwiper = new Swiper(thumbsEl, {
      slidesPerView: 4,
      spaceBetween: 15,
      watchSlidesProgress: true,
      breakpoints: {
        0: { slidesPerView: 3, spaceBetween: 8 },
        576: { slidesPerView: 4, spaceBetween: 15 },
      },
      navigation: {
        nextEl: slider.querySelector(".thumbs-next"),
        prevEl: slider.querySelector(".thumbs-prev"),
      },
    });

    new Swiper(mainEl, {
      spaceBetween: 10,
      thumbs: { swiper: thumbsSwiper },
    });
  });

  /* =========================
   * CARRIERES POSTES (NOUVEAU)
   * ========================= */
  const carrieresSwiperEl = document.querySelector(".carrieres-postes__swiper");

  if (carrieresSwiperEl) {
    const prevBtn = document.querySelector(".carrieres-postes__prev");
    const nextBtn = document.querySelector(".carrieres-postes__next");

    function updateArrowVisibility() {
      const perView = this.params.slidesPerView;
      const totalSlides = this.slides.length;

      const shouldHide = totalSlides <= perView;

      prevBtn.style.visibility = shouldHide ? "hidden" : "visible";
      nextBtn.style.visibility = shouldHide ? "hidden" : "visible";

      carrieresSwiperEl.classList.toggle("arrows-hidden", shouldHide);
    }

    const carriereSwiper = new Swiper(carrieresSwiperEl, {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: false,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
      on: {
        init: updateArrowVisibility,
        breakpoint: updateArrowVisibility,
        resize: updateArrowVisibility,
      },
    });
  }
});
